import React from 'react';

export default function HaveNoFiles() {
  return <div />;
}
